export default __webpack_public_path__ + "static/CenturyExpanded-Roman-77808d554d5bfd2432c349e402b676ca.woff";